/* global axios */
import ApiClient from '../ApiClient';

// Galeria de templates do Polaris AI (Fase 2): catálogo + install pela Agent Factory.
class PolarisTemplates extends ApiClient {
  constructor() {
    super('captain/templates', { accountScoped: true });
  }

  install(key, slots = {}) {
    return axios.post(`${this.url}/${key}/install`, { slots });
  }
}

export default new PolarisTemplates();
